import { UfoIcon } from '@modules/common/components/UfoIcon';
import { WarningAmberOutlined } from '@mui/icons-material';
import { Link, Stack, Typography } from '@mui/material';

interface ChartWidgetErrorMessageProps {
  onDataRefresh?: () => void;
}

export function ChartWidgetErrorMessage({
  onDataRefresh,
}: ChartWidgetErrorMessageProps) {
  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="center"
      sx={{ height: '100%' }}
    >
      <UfoIcon />
      <Stack direction="row" spacing={0.5} alignItems="center" mt={1}>
        <WarningAmberOutlined
          sx={{ color: 'error.light', width: 16, height: 16 }}
        />
        <Typography variant="subtitle1" color="error.light">
          Couldn't fetch data
        </Typography>
      </Stack>
      {onDataRefresh && (
        <Stack direction="row" spacing={0.5}>
          <Typography variant="subtitle1">Please</Typography>
          <Link component="button" variant="subtitle1" onClick={onDataRefresh}>
            Refresh the Query
          </Link>
        </Stack>
      )}
    </Stack>
  );
}
